import React from 'react'
import './Searchbar.css'
import { useState } from 'react'
import GetMovieData from './GetMovieData'
import moment from 'moment'
import { ObjectValues } from '../Components/Movie/objectsValues'
// import getMovieListData from '../Services/Queries/GetMovieListData'
// import { filterMoviesAndPersons } from '../Graphql/queries'
// import filterMoviesAndPersons from '../../Services/Queries/GetMovieListData'
import getMovieListData from '../Services/Queries/GetMovieListData'
import MovieReleaseDateAndEndDate from './MovieReleaseDateAndEndDate'

export default function SearchBar(props) {
  const {
    setSearchListTrue,
    setTotalRenderedCount,
    setfilterDisableWithoutSelect,
    setCheckBoxArr,
    setDisapperAllFilters,
    statusType,
    setIsLoading,
    setHeaders,
    searchValue,
    setLoaderServiceName,
    setMovieAndWebSeries,
    setmovieFilterByFromSearch,
    setcheckEmptyArray,
    setLodeMoreDisble,
    setFromvalue,
    setListMoviesDataItems,
    setsortBy,
    movieFilterBy,
    disapperAllFilters,
  } = props
  const limitval = 20
  const AfterInitialLoad = 20
  const [startDateInFormat, setStartDateInFormat] = useState()
  const [endDateInFormat, setEndDateInFormat] = useState()
  const [checkTrue, setCheckTrue] = useState(false)
  // const [movieFilterBy, setfilterObjects] = useState({})
  const [showDates, setShowDates] = useState(false)
  const [showDatePicker, setshowDatePicker] = useState(false)
  const [fixed10, setfixed10] = useState(20)

  // const [sortByorder, setsortOrderBy] = useState('desc')

  const [state, setState] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  })

  function openDatePicker() {
    setSearchListTrue(false)
    setshowDatePicker(!showDatePicker)
    setfilterDisableWithoutSelect(!showDatePicker)
  }

  function resetFunction() {
    setDisapperAllFilters(true)
    setFromvalue(AfterInitialLoad)
    props.setSearchQuery('')
    props.setSearch('')
    setMovieAndWebSeries('movies')
    setLoaderServiceName('filterMoviesAndPersons')
    setSearchListTrue(false)
    // const getlistmoviesdetais = async () => {
    //   setIsLoading(true)
    //   const input = {}
    //   input.limit = limitval
    //   input.sortOrder = props.sortByorderFromLIst
    //   input.from = 0
    //   input.search = searchValue
    //   input.sortBy = props.sortBy
    //   input.type = 'movies'
    //   movieFilterBy.status = 'published'
    //   input.movieFilterBy = movieFilterBy
    //   const movieList = await filterMoviesAndPersons(input)
    //   const arrayList = movieList.items && [...movieList.items]
    //   setListMoviesDataItems(arrayList)
    //   setFromvalue(limitval)
    //   setTotalRenderedCount(limitval)

    //   if (movieList.items.length === movieList.total) {
    //     setLodeMoreDisble(false)
    //   } else {
    //     setLodeMoreDisble(true)
    //   }

    //   if (arrayList.items.length > 0) {
    //     const finalHeaders = []
    //     ObjectValues.map(item => {
    //       finalHeaders.push({ path: item, name: item })
    //       return finalHeaders
    //     })
    //     const finalHeadersFilterd = finalHeaders.filter(
    //       item => item.name !== 'PK' && item.name !== 'SK' && item.name !== '__typename',
    //     )
    //     setHeaders(finalHeadersFilterd)
    //   }

    //   setIsLoading(false)
    // }
    const getlistmoviesdetails = async () => {
      try {
        setIsLoading(true)

        const input = {
          limit: limitval,
          sortOrder: 'desc',
          from: 0,
          search: '',
          sortBy: 'releaseYear',
          type: 'movies',
        }
        // movieFilterBy.status = statusType
        input.movieFilterBy = {
          status: statusType,
        }

        // const movieList = await getMovieListData(input)
        //   const input = {
        //   limit: Limit,
        //   sortOrder: sortByorderFromLIst,
        // }
        // input.from = fromValue
        // input.search = searchValue
        // input.sortBy = sortBy
        // input.type = movieAndWebSeries
        // if (Object.keys(movieFilterBy).length >= 1) {
        // movieFilterBy.status = statusType
        // input.movieFilterBy = movieFilterBy
        setCheckBoxArr([]) // Reset array when status changes

        const movieList = await getMovieListData(input)

        const arrayList = movieList.items ? [...movieList.items] : []
        setListMoviesDataItems(arrayList)
        setFromvalue(limitval)
        setTotalRenderedCount(limitval)

        setLodeMoreDisble(movieList.items.length === movieList.total)

        if (arrayList.length > 0) {
          const finalHeaders = ObjectValues.map(item => ({ path: item, name: item }))
          const finalHeadersFilterd = finalHeaders.filter(
            item => !['PK', 'SK', '__typename'].includes(item.name),
          )
          setHeaders(finalHeadersFilterd)
        }

        setIsLoading(false)
      } catch (error) {
        console.error('Error:', error)
        setIsLoading(false)
      }
    }

    getlistmoviesdetails()
  }

  function handleSelect(dates) {
    if (moment(dates.selection.startDate).format() !== moment(dates.selection.endDate).format()) {
      setshowDatePicker(false)
    } else if (dates.selection.startDate === '' && dates.selection.endDate === '') {
      setshowDatePicker(false)
    }

    setFromvalue(AfterInitialLoad)

    const start = new Date(dates.selection.startDate)
    start.setHours(0, 0, 0, 0)
    const end = new Date(dates.selection.endDate)
    end.setHours(23, 59, 59, 999)

    const dateObj = {
      startDate: start,
      endDate: end,
      key: 'selection',
    }

    const year = dateObj.startDate.toLocaleString('default', { year: 'numeric' })
    const month = dateObj.startDate.toLocaleString('default', { month: '2-digit' })
    const day = dateObj.startDate.toLocaleString('default', { day: '2-digit' })
    const year1 = dateObj.endDate.toLocaleString('default', { year: 'numeric' })
    const month1 = dateObj.endDate.toLocaleString('default', { month: '2-digit' })
    const day1 = dateObj.endDate.toLocaleString('default', { day: '2-digit' })
    const startDateInFormat = year + month + day
    const endDateInFormat = year1 + month1 + day1
    delete movieFilterBy.movieReleaseStartDate
    delete movieFilterBy.movieReleaseEndDate

    movieFilterBy.movieReleaseStartDate = Number(startDateInFormat)
    movieFilterBy.movieReleaseEndDate = Number(endDateInFormat)
    setStartDateInFormat(startDateInFormat)
    setEndDateInFormat(endDateInFormat)
    setState(dateObj)
    setCheckTrue(false)

    setShowDates(true)
  }

  const getFormattedDate = date => {
    let dd = date.getDate()
    let mm = date.getMonth() + 1

    const yyyy = date.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    const formattedDate = dd + '/' + mm + '/' + yyyy
    const hh = date.getHours()
    let m = date.getMinutes()
    let d = 'AM'
    let h = hh
    if (h >= 12) {
      h = hh - 12
      d = 'PM'
    }

    if (h === 0) {
      h = 12
    }

    m = m < 10 ? '0' + m : m
    const formattedTime = h + ':' + m + ' ' + d
    return formattedDate + ' ' + formattedTime
  }

  const removeDate = () => {
    setState({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    })
    setshowDatePicker(false)
    setShowDates(false)
    delete movieFilterBy.movieReleaseStartDate
    delete movieFilterBy.movieReleaseEndDate
    setCheckTrue(false)
  }

  const handleResetData = () => {
    setSearchListTrue(false)
    setFromvalue(AfterInitialLoad)
    props.handleStatusType('published')
    setfilterDisableWithoutSelect(true)
    resetFunction()
    props.setsortByorderFromLIst('desc')
    setsortBy('releaseYear')
    setmovieFilterByFromSearch({})
    setShowDates(false)
    props.setSearch('')
    setCheckTrue(false)
  }

  return (
    <div>
      <div className='search-container' style={{ marginTop: '8px' }}>
        <div className='searchbar' style={{ margin: '4px 0px' }}></div>
      </div>
      <MovieReleaseDateAndEndDate
        openDatePicker={openDatePicker}
        showDates={showDates}
        statusType={statusType}
        getFormattedDate={getFormattedDate}
        state={state}
        removeDate={removeDate}
        handleSelect={handleSelect}
        showDatePicker={showDatePicker}
        disapperAllFilters={disapperAllFilters}
      />
      <div className='date2'>
        <div className='enddate' style={{ marginRight: '10px' }}></div>
      </div>
      <label htmlFor='languages'>status</label>
      <select
        required
        name='select'
        id='languages'
        onChange={e => props.handlePublishedStatus(e)}
        value={statusType}
      >
        <option value='published'>published</option>
        <option value='draft'>Draft</option>
      </select>
      <div>
        <GetMovieData
          sortOrderReset={props.sortOrderReset}
          sortByReset={props.sortByReset}
          limitval={limitval}
          // AfterInitialLoad={AfterInitialLoad}
          handleResetData={handleResetData}
          movieAndWebSeries={props.movieAndWebSeries}
          disapperAllFilters={props.disapperAllFilters}
          showDates={showDates}
          showDatePicker={showDatePicker}
          setTotalRenderedCount={setTotalRenderedCount}
          setFromvalue={setFromvalue}
          setSearchListTrue={setSearchListTrue}
          resetFunction={resetFunction}
          filterDisableWithoutSelect={props.filterDisableWithoutSelect}
          setfilterDisableWithoutSelect={setfilterDisableWithoutSelect}
          handleStatusType={props.handleStatusType}
          setsortByorderFromLIst={props.setsortByorderFromLIst}
          sortBy={props.sortBy}
          setsortBy={setsortBy}
          statusType={statusType}
          handlePublishedStatus={props.handlePublishedStatus}
          fixed10={fixed10}
          setfixed10={setfixed10}
          setmovieFilterByFromSearch={setmovieFilterByFromSearch}
          setCheckTrue={setCheckTrue}
          checkTrue={checkTrue}
          setShowDates={setShowDates}
          setfilterObjects={setmovieFilterByFromSearch}
          startDateInFormat={startDateInFormat}
          endDateInFormat={endDateInFormat}
          movieFilterBy={movieFilterBy}
          setEndDateInFormat={setEndDateInFormat}
          setSearch={props.setSearch}
          searchValue={searchValue}
          state={state}
          setcheckEmptyArray={setcheckEmptyArray}
          setCheckBoxArr={setCheckBoxArr}
          setLodeMoreDisble={setLodeMoreDisble}
          setLoaderServiceName={props.setLoaderServiceName}
          setListMoviesDataItems={setListMoviesDataItems}
          // setGetNextToken={setGetNextToken}
          sortByorder={props.sortByorder}
          setsortOrderBy={props.setsortOrderBy}
        />
      </div>
      <div></div>
    </div>
  )
}
